<template>
  <div v-if="isLoading">
    <loading />
  </div>
  <div v-else class="p-5">
    <excelExport @exportexcel="getExcel()" />
    <table class="font-thin text-gray-700 text-sm table-auto">
      <thead class="font-black text-left">
        <tr>
          <td>
            <div class="page-header-space"></div>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            <h1>
              Listado de citas de la agenda con Colecciones
            </h1>
          </td>
        </tr>
        <tr>
          <td class="w-1/12">Fecha</td>
          <td class="w-1/12">Hora</td>
          <td class="w-2/12">Usuario</td>
          <td class="w-3/12">Cliente</td>
          <td class="w-5/12">Observaciones</td>
        </tr>
      </thead>
      <tr
        v-for="temporada in report.temporadas"
        :key="temporada.idTipoTemporada"
      >
        <td colspan="5" class="bloque leading-none">
          <table class="border-2 border-gray-800 font-semibold">
            <tr>
              <td colspan="5" class="w-2/12">
                {{ temporada.tipoTemporada }}  {{ temporada.anyo }}  ( {{temporada.citas.length}} )
              </td>
              
             
            </tr>
          </table>
          <table class="mb-2 leading-1 print:leading-3">
            <tr class=" bloque border-b-2 pt-2" v-for="cita in temporada.citas" :key="cita.idCita">
              <td colspan="5">
                <table class="mb-2 leading-1 print:leading-3">
                  <tr>
                    <td class="w-1/12 p-1">
                      {{ cita.fecha }}
                    </td>
                    <td class="w-1/12 p-1">
                      {{ cita.hora }}
                    </td>
                    <td class="w-2/12 p-1">
                      {{ cita.usuario }}
                    </td>
                    <td class="w-3/12 p-1">
                      {{ cita.nombreCliente }}
                    </td>
                    <td class="w-5/12 p-1">
                      {{ cita.observaciones }}
                    </td>
                  </tr>
                  <tr v-if="detail">
                    <td colspan="2"></td>
                    <td colspan="3">
                      {{ cita.poblacionCliente}} - {{ cita.tiendasCliente}} - {{ cita.contactoCliente}}
                    </td>
                  </tr>
                </table>

                <table v-if="detail">
                  <tr>
                    <td width="15%"></td>
                    <td>
                      <table class="px-10" v-if="cita.colecciones.length !=  1 || cita.colecciones[0].idColeccion != '0'"> 
                        <thead class="border-b-2">
                          <tr>
                            <td class="text-left">Colección</td>
                            <td class="text-right">Prendas</td>
                            <td class="text-right">Importe</td>
                          </tr>
                        </thead>
                        <tr class="border-b-2 pt-2" v-for="coleccion in cita.colecciones" :key="coleccion.idColeccion">
                          <td>
                            {{ coleccion.descripcionColeccion }} 
                          </td>
                          <td class="text-right">
                            {{ coleccion.totalPrendasConfirmadas }}
                          </td>
                          <td class="text-right">
                            {{ coleccion.totalImporteConfirmado }}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td width="15%"></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <footerPage></footerPage>
  <div class="header p-10">
    <table>
      <tr>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { AgendaCitasConColecciones } from "@/types/reports/agenda/agendaCitasConColecciones/AgendaCitasConColecciones";
import { CitaFilter } from "@/types/agenda/CitaView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import { useRoute } from "vue-router";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<AgendaCitasConColecciones> = ref({
      temporadas: []
    });

    const route = useRoute();
    const param = route.params.years.toString();

    const detail = ref(true);

    const isLoading = ref(true);

    detail.value = route.params.detail == "yes";
    //console.log(detail.value);
    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("agendaFilter");
      let filter = {} as CitaFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportAgendaCitasConColeccionesDB(filter, param);
      report.value = response;
      isLoading.value = false;
      //console.log(report);
    }

    async function getExcel() {
      const filterString = localStorage.getItem("agendaFilter");
      let filter = {} as CitaFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      let detalle = "";
      if (detail.value) {detalle = "yes"} else {detalle = "no"};
      apiExcel.getReportAgendaCitasConColeccionesDB(filter, param, detalle);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
</script>
<style scoped>
table {
  width: 100%;
}

table table {
  /*text-align: left;*/
}

thead td {
  /*text-align: center;*/
}

/*.bloque {
  page-break-inside: avoid;
}*/

.header {
  font-size: 9px;
  line-height: 10px;
  position: fixed;
  top: 0;
  visibility: hidden;
  counter-increment: page;
}

@media print {
  table {
    font-size: 10px;
  }
  td {
    line-height: 0.75rem;
  }
  @page {
    size: portait;
  }

  .header {
    visibility: visible;
  }

  .page-footer-space {
    height: 20px;
  }

  .page-header-space {
    height: 0px;
  }
}
</style>